import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TreeRefer, Row, Col, Label, Input, Cascader } from 'yxyweb/common/components/basic'
import { Button, Select,Icon } from 'antd';
import Cookies from 'cookies-js';
import UpLoadFace from 'yxyweb/common/components/account-center/UploadFace';
import * as systemSettingactions from 'yxyweb/common/redux/systemSetting';
import * as tabsactions from 'yxyweb/common/redux/tabs';

class CompanyInfoControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: {},
            oldName: ''
        };
        this.treeModel = new cb.models.TreeModel({ dataSourceMode: 'a', keyField: 'id', titleField: 'name' })
        this.industryOptions=[];
    }
    componentDidMount() {
        var proxy = cb.rest.DynamicProxy.create({
            getDetail: {
                url: '/tenant/find.do',
                method: 'GET',
                options: { token: true }
            },
            getIndustry: {
                url: 'enum/getEnumMap',
                method: 'GET',
                options: { token: true }
            }
        });
        proxy.getIndustry({enumtype: 'aa_tradetype'}, function (err, result ) {
            if (err) {
                console.error(err.message);
                cb.utils.alert(err.message, 'error');
                return;
            }
            this.getIndustryOptions(result)
            proxy.getDetail({}, function (err, result) {
                if (err) {
                    console.error(err.message);
                    cb.utils.alert(err.message, 'error');
                    return;
                }
                this.props.systemSettingactions.companyInfoMerge({hasOpenUdh: result.isOpenUdh});
                this.setState({ dataSource: result, oldName: result.name });
                this.treeModel.setDataSource({ url: '/region/getAllregion', method: 'POST' });
                this.treeModel.on('afterSetDataSource', function (data) {
                    let rCode = self.state.dataSource.regionCode;
                    let value = [];
                    let value2 = [];
                    while (rCode != undefined && rCode != "") {
                        value.push(rCode);
                        var nodes = self.treeModel.getNodesByKeys(rCode);;
                        if (nodes != undefined && nodes.length > 0) {
                            rCode = nodes[0].parent;
                        }
                        else {
                            rCode = "";
                        }
                    }
                    if (value.length > 0) {
                        for (var i = 1; i <= value.length; i++) {
                            value2.push(value[value.length - i]);
                        }
                    }
                    self.treeModel.setValue(value2);
                }, self = this);
            }, this)
        },this)
    }
    getIndustryOptions(data){
        let arr = [];
        for(let attr in data){
            arr.push(<Select.Option key={attr}>{data[attr]}</Select.Option>)
        }
        this.industryOptions=arr;
    }
    componentWillUnmount() {
        const { systemSettingactions } = this.props;
        systemSettingactions.unMount();
    }
    getInputControl=(InputControl,cShowCaption,bIsNull) =>{
      const title = bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
      let control = cShowCaption ? <Label control={InputControl} title={title} /> :<Label control={InputControl} />
      return control;
    }
    render() {
        const { systemSetting } = this.props;
        return (  
            <div className="company-info">
                <div className='info-content'>
                    <Row>
                        <Col span={24}>
                            <div className="viewSetting viewCell width-percent-100">
                                <Row>
                                    <Col className='label-control logo-face-label' span={4}><label>企业LOGO</label></Col>
                                    <Col className='input-control' span={16}>
                                        <Row className="face-img companyInfo-logo-img">
                                            <UpLoadFace 
                                                class_name='face-img companyInfo-logo-img' 
                                                toolClass='info-person'
                                                imgUrl={systemSetting.logo ? systemSetting.logo : this.state.dataSource.logo} 
                                                imageChange={(url)=>this.logoChange(url, 'logo')}
                                            />
                                            <span>仅支持JPG、JPEG、BMP、PNG格式，文件小于1M（建议最佳尺寸144*60px）</span>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input ref="err" err={systemSetting.nameErrMsg ? 'has-error' : null} defaultValue={this.state.dataSource.name} onBlur={(value) => this.handleInputBlur("name", value, true)} onChange={(value) => this.onTaxChange(value)} placeholder='请输入公司名称' />,
                                "公司名称",false
                              )}
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input defaultValue={systemSetting.taxId ? systemSetting.taxId : this.state.dataSource.taxId} onBlur={(value) => this.handleInputBlur("taxId", value)} placeholder='请输入纳税人识别号' />,
                                "公司名称",true
                              )}
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input ref="err" err={systemSetting.nameErrMsg ? 'has-error' : null} defaultValue={this.state.dataSource.alias} onBlur={(value) => this.handleInputBlur("alias", value, true)} placeholder='请输入别名代码' disabled={true} />,
                                "别名代码",false
                              )}
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input ref="err" err={systemSetting.phoneErrMsg ? 'has-error' : null} defaultValue={this.state.dataSource.phone} onBlur={(value) => this.handleInputBlur("phone", value, true)}  placeholder='请输入联系人电话' />,
                                 "联系人电话",false
                              )}
                              <span className="err-info">{systemSetting.phoneErrMsg ? '请填写正确的电话号码' : ''}</span>
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input ref="err" err={systemSetting.emailErrMsg ? 'has-error' : null} defaultValue={this.state.dataSource.email} onBlur={(value) => this.handleInputBlur("email", value, true)} placeholder='请输入公司邮箱' />,
                                "公司邮箱",false
                              )}
                              <span className="err-info">{systemSetting.emailErrMsg ? '请填写正确的邮箱号' : ''}</span>
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input defaultValue={this.state.dataSource.fax} onBlur={(value) => this.handleInputBlur("fax", value)} placeholder='请输入公司传真' />,
                                "公司传真",true
                              )}
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input defaultValue={this.state.dataSource.website} onBlur={(value) => this.handleInputBlur("website", value)} placeholder='请输入公司网址'/>,
                               "公司网址",true
                              )}
                              </div>
                            <div className="viewSetting viewCell width-percent-100">
                                <Label control={<Select disabled value={this.state.dataSource.industry!=undefined?this.state.dataSource.industry.toString():''} onChange={key=>this.handleIndustryChange(key)} placeholder='请输入行业' cShowCaption="所属行业">{this.industryOptions ? this.industryOptions : null}</Select>} title='所属行业' />
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                                {/*<TreeRefer cShowCaption='所属区域' ref='region' cRefType='aa_areaclass' value={this.state.dataSource.region_name} afterOkClick={(value)=>this.mapValueChange('region',value)} placeholder='请选择所属区域'/>*/}
                              {this.getInputControl(
                                <Cascader ref='regionCode' model={this.treeModel} />,
                                "所在地区",true
                              )}
                            </div>
                            <div className="viewSetting viewCell width-percent-100">
                              {this.getInputControl(
                                <Input cStyle='{"type":"textarea","rows":3}' defaultValue={this.state.dataSource.address} onBlur={(value) => this.handleInputBlur("address", value, false)} placeholder='请输入详细地址' />,
                               "详细地址",true
                              )}
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className='ant-row-flex ant-row-flex-start btn-toolbar-bottom btn-group-bottom bottom-toolbar'>
                    <Row colCount={12}>
                        <Button type='primary' className='m-l-148' onClick={() => this.handleSaveClick()}>保存</Button>
                        <Button type="default" className='m-l-10' onClick={() => this.handleCancelClick()}>取消</Button>
                    </Row>
                </div>
            </div>
        )
    }
    logoChange(url, type){
        let { systemSettingactions } = this.props;
        let obj = {};
        obj[type] = url
        systemSettingactions.companyInfoMerge(obj)
    }
    onTaxChange(value) {
        let { dataSource } = this.state;
        this.props.systemSettingactions.companyInfoMerge({ taxId: '' });
        dataSource.taxId = '';
        dataSource.name = value;
        this.setState({ dataSource })
    }
    handleIndustryChange(key) {
        let dataSource = this.state.dataSource;
        dataSource.industry = key;
        this.setState(dataSource)
    }
    mapValueChange(type, value) {
        let referDataSource = this.state.dataSource;
        referDataSource[type] = value[0].id;
        this.setState(referDataSource)
    }
    handleInputBlur(flag, value, isStar) {
        let { systemSettingactions, systemSetting } = this.props;
        const pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        let dataSource = this.state.dataSource;
        let flagErrMsg = flag + 'ErrMsg';
        let middle = {};
        dataSource[flag] = value;
        if (isStar === true) {
            if (value) {
                middle[flagErrMsg] = false
                systemSettingactions.companyInfoMerge(middle)
            } else {
                middle[flagErrMsg] = true;
                systemSettingactions.companyInfoMerge(middle)//发送错误标志的信息
                // cb.utils.alert('该选型为必填项，请填写！', 'warning');
            }
        }
        if (flag == 'phone') {
            if (value) {
                if (pattern.test(value)) {
                    middle[flagErrMsg] = false
                    systemSettingactions.companyInfoMerge(middle)
                } else {
                    middle[flagErrMsg] = true;
                    systemSettingactions.companyInfoMerge(middle)//发送错误标志的信息
                    // cb.utils.alert('请填写正确的电话号码！', 'warning');
                }
            }
        }
        if(flag === 'email') {
            if(value){
                if(/^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/.test(value)){
                    middle[flagErrMsg] = false
                    systemSettingactions.companyInfoMerge(middle)
                }else{
                     middle[flagErrMsg] = true;
                    systemSettingactions.companyInfoMerge(middle)//发送错误标志的信息
                    // cb.utils.alert('请填写正确的邮箱！', 'warning');
                }
            }
        }
        if(flag === 'name'){
            if(this.state.oldName === value) return //避免重复查
            this.props.systemSettingactions.getTaxNo(value);
            this.setState({ oldName: value })
        }
        this.setState({ dataSource });
    }
    handleCancelClick() {
        this.props.tabsactions.deleteItem('AA0001')
    }
    handleSaveClick() {
        let { systemSetting } = this.props;
        let isOpen = true;
        let dataSource = this.state.dataSource;
        let mustOptions = [dataSource.alias, dataSource.name, dataSource.phone, dataSource.email];
        let regionValue = this.treeModel.getValue();
        //错误标记
        mustOptions.forEach((value) => {
            if (value === null || value === '') {
                isOpen = false;
            }
        })
        if (!isOpen) {
            cb.utils.alert('存在为必填项，请填写！', 'error');
            return
        }
        if (systemSetting.logo) this.state.dataSource.logo = systemSetting.logo;
        if (systemSetting.bizLogo) this.state.dataSource.bizLogo = systemSetting.bizLogo;
        if (systemSetting.taxId) this.state.dataSource.taxId = systemSetting.taxId;
        this.state.dataSource.pubts = null;
        if (regionValue)
            this.state.dataSource.regionCode = regionValue[regionValue.length - 1];
        this.saveData(this.state.dataSource)
    }
    saveData(data) {
        let saveLogo = this.state.dataSource.logo, saveBizLogo = this.state.dataSource.bizLogo;
        let { systemSettingactions, systemSetting } = this.props;
        var proxy = cb.rest.DynamicProxy.create({
            save: {
                url: '/tenant/save.do',
                method: 'POST',
                options: { token: true }
            }
        });
        proxy.save(data, function (err, result) {
            if (err) {
                console.error(err.message);
                cb.utils.alert('存在为必填项，请填写！', 'error');
                return;
            }
            cb.utils.alert('保存成功！', 'success')
            // const user = JSON.parse(Cookies.get('user'));
            // user.logo = data.logo;
            // const expires = new Date(Date.now() + 24 * 3600 * 1000)
            // Cookies.set('user', JSON.stringify(user), {
            //     path: '/',
            //     expires
            // });
            systemSettingactions.passLogo({ logo: saveLogo, bizLogo: saveBizLogo });

        })
    }
}

function mapStateToProps(state) {
    return {
        systemSetting: state.systemSetting.toJS()
    }
}

function mapDispatchToProps(dispatch) {
    return {
        systemSettingactions: bindActionCreators(systemSettingactions, dispatch),
        tabsactions: bindActionCreators(tabsactions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyInfoControl);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/account-center/CompanyInfo.jsx